let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("41xXq")).then(() => parcelRequire('f6uqq'));